/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 判断是否为 null
 * @param value
 * @returns boolean
 */
function isNull(value: any): boolean {
  return value == null;
}

export default isNull;
